import script from "./PricingAndMarginMixin.vue?vue&type=script&lang=js"
export * from "./PricingAndMarginMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__